import { left } from "@popperjs/core";
import { install_app, godo } from "./common";
import * as bootstrap from "bootstrap";


let HAS_MARKETPLACE_BEEN_RENDERED = false;
const MARKETPLACE_URL = "https://raw.githubusercontent.com/Eth0s-Group/Z2-Marketplace/main/market.json";
const APP_REPO = document.querySelector("#app_repo");
const MODAL_BODY = APP_REPO.querySelector(".modal-body");
let z2_apps = [];

function proxy(url){
    return `https://z2-liberator-cors-proxy.eth0s.dev/corsproxy/?apiurl=${encodeURIComponent(url)}`
}

async function update_apps() {
    z2_apps = (await godo("pm list packages", false, true)).stdout.replaceAll("package:", "").split("\n");
    console.log(z2_apps);
}

document.querySelector("#app_repo_launcher").addEventListener("click", () => {
    if (!HAS_MARKETPLACE_BEEN_RENDERED) {
        render_marketplace()
    }
    new bootstrap.Modal(document.querySelector("#app_repo")).show()
});

document.querySelector("#refresh_repo").addEventListener("click", render_marketplace);

async function installer(btn) {
    btn.setAttribute("disabled", "true")
    btn.textContent = "Installing dependencies...";
    const dependencies = eval(btn.getAttribute("data-deps")) || [];
    console.log(dependencies);
    for (const dep of dependencies) {
        console.log(dep);
        if (!z2_apps.includes(dep)) {
            await installer(document.getElementById("install_" + dep));
        }
    }
    btn.textContent = "Downloading...";
    let blobby = null;
    try {
        blobby = await (await fetch(proxy(btn.getAttribute("data-url")))).blob();
    } catch (e) {
        console.error(e);
        btn.textContent = "Error downloading :(";
        return;
    }
    btn.textContent = "Installing app..."
    try {
        await install_app(blobby);
    } catch (e) {
        console.error(e);
        btn.textContent = "Error installing :(";
        return;
    }
    if (btn.getAttribute("data-postinstall") != "undefined") {
        btn.textContent = "Running post-install...";
        try {
            await godo(btn.getAttribute("data-postinstall"));
        } catch (e) {
            console.error(e);
            btn.textContent = "Error running post-install :(";
            return;
        }
    }
    if (dependencies.includes("moe.shizuku.privileged.api")) {
        // btn.textContent = "Granting Shizuku permissions...";
        // try {
        //     await godo(`pm grant ${btn.getAttribute("data-id")} moe.shizuku.manager.permission.API_V23`);
        // } catch(e) {
        //     console.error(e);
        //     btn.textContent = "Error granting Shizuku permissions :("
        //     return;
        // }
        btn.textContent = "Attempting to start Shizuku to make your life easier...";
        godo(`sh /sdcard/Android/data/moe.shizuku.privileged.api/start.sh`);
    }
    update_apps();
    btn.textContent = "Installed!"
}

async function render_marketplace(){
    try {
        await update_apps();
    } catch (e) {
        console.error(e);
        MODAL_BODY.textContent = "Unable to communicate with Z2.  Please connect Z2 to use the marketplace."
        return;
    }
    const mkt_resp = await ( await fetch(MARKETPLACE_URL) ).json()
    APP_REPO.querySelector(".modal-header").querySelector("h1").textContent = mkt_resp.name;
    MODAL_BODY.innerHTML = "";
    APP_REPO.querySelector(".modal-dialog").style.maxWidth = "100%";
    for (const app_id of Object.keys(mkt_resp.apps)) {
        const app = mkt_resp.apps[app_id];
        const tile = document.createElement("div");
        tile.style.borderBottom = "medium solid gray";
        tile.style.marginBottom = "22px";
        const left_half = document.createElement("div");
        
        const right_half = document.createElement("div");
        const img = document.createElement("img");
        img.src = app.icon;
        img.style.height = "32px";
        img.style.width = "32px";
        left_half.appendChild(img);
        const install_btn = document.createElement("button");
        install_btn.classList.add("btn", "btn-primary");
        install_btn.id = "install_" + app_id;
        install_btn.setAttribute("data-id", app_id);
        install_btn.setAttribute("data-url", app.downloadUrl);
        install_btn.setAttribute("data-deps", JSON.stringify(app.dependencies));
        install_btn.setAttribute("data-postinstall", app.postinstall);
        install_btn.addEventListener("click", () => {
            installer(install_btn);
        });
        install_btn.textContent = !z2_apps.includes(app_id) ? "Install" : "Reinstall/Update";
        left_half.appendChild(install_btn);
        tile.appendChild(left_half);
        const title = document.createElement("h3");
        title.textContent = app.name;
        right_half.appendChild(title);
        const desc = document.createElement("pre");
        desc.textContent = app.description;
        right_half.appendChild(desc);
        const attrib = document.createElement("a");
        attrib.textContent = app.attribution.name;
        attrib.href = app.attribution.link;
        attrib.target = "_blank";
        right_half.appendChild(attrib);
        tile.appendChild(right_half);
        MODAL_BODY.appendChild(tile);
    }
    HAS_MARKETPLACE_BEEN_RENDERED = true;
}